<template>
  <li class="relative" @mouseenter="desktopOpen = true" @mouseleave="desktopOpen = false">
    <div class="flex items-center">
      <a
        v-if="isExternal"
        :href="item.link"
        target="_blank"
        rel="noopener noreferrer"
        :class="linkClass"
        @click="$emit('navigate')"
      >{{ item.title }}</a>
      <router-link
        v-else
        :to="resolvedLink"
        :class="linkClass"
        @click="$emit('navigate')"
      >{{ item.title }}</router-link>

      <button
        v-if="children.length"
        type="button"
        class="shrink-0 rounded-lg p-2 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800"
        :aria-expanded="isOpen"
        :aria-label="item.title"
        @click.stop="mobileOpen = !mobileOpen"
      >
        <svg class="h-4 w-4 transition-transform" :class="{ 'rotate-180': isOpen }" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.17l3.71-3.94a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>

    <ul
      v-if="children.length"
      v-show="isOpen"
      class="dynamic-submenu z-50 min-w-52 rounded-xl border border-slate-200 bg-white p-2 shadow-xl dark:border-slate-700 dark:bg-slate-900"
    >
      <DynamicMenuItem
        v-for="child in children"
        :key="child.id || child.title"
        :item="child"
        :lang-path="langPath"
        :mobile="mobile"
        @navigate="$emit('navigate')"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: "DynamicMenuItem",
  props: {
    item: { type: Object, required: true },
    langPath: { type: String, required: true },
    mobile: { type: Boolean, default: false },
  },
  emits: ["navigate"],
  data() {
    return { desktopOpen: false, mobileOpen: false };
  },
  computed: {
    children() {
      return Array.isArray(this.item.items)
        ? this.item.items.filter((child) => child && typeof child === "object")
        : [];
    },
    isExternal() {
      return /^(https?:)?\/\//i.test(this.item.link || "");
    },
    resolvedLink() {
      const link = (this.item.link || "").trim();
      if (!link || link === "#") return this.langPath;
      if (link.startsWith(this.langPath + "/") || link === this.langPath) return link;
      if (/^\/(fa|ar|en)(\/|$)/i.test(link)) return link;
      return `${this.langPath}/${link.replace(/^\/+/, "")}`.replace(/\/$/, "");
    },
    isOpen() {
      return this.mobile ? this.mobileOpen : this.desktopOpen || this.mobileOpen;
    },
    linkClass() {
      return this.mobile
        ? "block min-w-0 flex-1 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-100 hover:text-primary dark:text-slate-200 dark:hover:bg-slate-800"
        : "block whitespace-nowrap rounded-xl px-3 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-200/70 hover:text-primary dark:text-slate-200 dark:hover:bg-slate-800";
    },
  },
};
</script>

<style scoped>
.dynamic-submenu { position: absolute; inset-inline-start: 0; top: 100%; }
.dynamic-submenu .dynamic-submenu { inset-inline-start: 100%; top: 0; }
@media (max-width: 1279px) {
  .dynamic-submenu { position: static; margin: .25rem .75rem .5rem; box-shadow: none; }
}
</style>
